export default {
      id: "gas-pump-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#gas-pump",
      toString: function () {
        return this.url;
      }
    }